import { render, staticRenderFns } from "./LayoutHistoryModal.vue?vue&type=template&id=3c0556c8&scoped=true"
import script from "./LayoutHistoryModal.vue?vue&type=script&lang=ts"
export * from "./LayoutHistoryModal.vue?vue&type=script&lang=ts"
import style0 from "./LayoutHistoryModal.vue?vue&type=style&index=0&id=3c0556c8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0556c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c0556c8')) {
      api.createRecord('3c0556c8', component.options)
    } else {
      api.reload('3c0556c8', component.options)
    }
    module.hot.accept("./LayoutHistoryModal.vue?vue&type=template&id=3c0556c8&scoped=true", function () {
      api.rerender('3c0556c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/LayoutHistoryModal.vue"
export default component.exports